export const cardProps = {
  color: 'primary',
  class: 'card',
}
